/** @format */

import React from "react"
import { Select } from "antd"
import { Field } from "formik"
import { Input } from "../_metronic/_partials/controls"
import DatePicker, { Calendar, utils } from "react-modern-calendar-datepicker"
import { useMediaQuery } from "react-responsive"
import {
  createMuiTheme,
  Dialog,
  InputAdornment,
  makeStyles,
  MuiThemeProvider,
  TextField,
  Select as MatSelect,
} from "@material-ui/core"
import plateIMG from "../ebusHomePics/Pelak.png"
import { DropzoneArea } from "material-ui-dropzone"
import persianAlphabets from "./persianAlphabets"
import fixNumbers from "./fixNumbers"

const { OptGroup, Option } = Select

const useStyles = makeStyles(() => ({
  noBorder: {
    border: "none",
  },
}))

const Fieldz = (fieldProps) => {
  const [datepickerModal, setDatePickerModal] = React.useState(false)
  const [selectedDay, setSelectedDay] = React.useState(null)
  const classes = useStyles()

  const theme = createMuiTheme({
    overrides: {
      MuiOutlinedInput: {
        root: {
          "& $notchedOutline": {
            border: "none",
          },
        },
      },
    },
  })

  const {
    name,
    placeholder,
    type,
    errors,
    touched,
    disabled,
    value,
    defaultValue,
  } = fieldProps
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` })

  switch (type) {
    case "text":
      return (
        <div
          className={`${
            fieldProps.customCol ? fieldProps.customCol : "col-12 col-md-6"
          } d-flex justify-content-center flex-column align-items-center p-5`}
          style={{ gap: "8px" }}
        >
          {fieldProps.label && (
            <h6 className={`my-auto mr-auto ${fieldProps.labelClassName}`}>
              {fieldProps.label}
            </h6>
          )}
          <Field
            name={name}
            placeholder={placeholder}
            defaultValue={defaultValue}
            type="text"
            value={value}
            style={{
              height: "4rem",
              borderRadius: 13,
              border: "1px solid #d9d9d9",
            }}
            onChange={(e) => {
              fieldProps.setValue(name, fixNumbers(e.target.value))
            }}
            className="w-100 p-5"
            component={Input}
            disabled={disabled}
          />
          {fieldProps.customTouchAndError ? (
            touched && <h6 className="my-auto text-danger mr-auto">{errors}</h6>
          ) : (
            <>
              {touched[name] && (
                <h6 className="my-auto text-danger mr-auto">{errors[name]}</h6>
              )}
            </>
          )}
        </div>
      )
    case "number":
      return (
        <div
          className="col-12 col-md-6 d-flex justify-content-center flex-column align-items-center p-5"
          style={{ gap: "8px" }}
        >
          <Field
            name={name}
            placeholder={placeholder}
            defaultValue={defaultValue}
            style={{
              height: "4rem",
              borderRadius: 13,
              border: "1px solid #d9d9d9",
            }}
            onChange={(e) => {
              fieldProps.setValue(name, fixNumbers(e.target.value))
            }}
            value={value}
            className="w-100 p-5"
            component={Input}
            disabled={disabled}
          />
          {fieldProps.customTouchAndError ? (
            touched && <h6 className="my-auto text-danger mr-auto">{errors}</h6>
          ) : (
            <>
              {touched[name] && (
                <h6 className="my-auto text-danger mr-auto">{errors[name]}</h6>
              )}
            </>
          )}
        </div>
      )
    case "Select":
      return (
        <div
          className="col-12 col-md-6 d-flex justify-content-center flex-column align-items-center p-5"
          style={{ gap: "8px" }}
        >
          <Select
            showSearch
            defaultValue={defaultValue}
            optionFilterProp="children"
            style={{ borderRadius: "13px", height: "4rem" }}
            className="w-100 ant-select"
            onChange={(e, a) => {
              fieldProps.setValue(a)
            }}
            value={fieldProps.value}
            placeholder={
              <span
                className="d-flex align-items-center"
                style={{ gap: "5px" }}
              >
                <h5 className="mx-auto my-auto text-muted">{placeholder}</h5>
              </span>
            }
          >
            {fieldProps.data
              ? fieldProps.data.map((province) => {
                  return (
                    <OptGroup label={province.title}>
                      {province.Townships.map((towns) => {
                        return (
                          <Option value={towns.code} id={towns.id}>
                            <i
                              className="fa fa-map-marker"
                              style={{
                                fontSize: 15,
                                color: "#6dd06d",
                              }}
                            ></i>{" "}
                            {towns.title}
                          </Option>
                        )
                      })}
                    </OptGroup>
                  )
                })
              : []}
          </Select>
          {fieldProps.customTouchAndError ? (
            touched && <h6 className="my-auto text-danger mr-auto">{errors}</h6>
          ) : (
            <>
              {touched[name] && (
                <h6 className="my-auto text-danger mr-auto">{errors[name]}</h6>
              )}
            </>
          )}
        </div>
      )
    case "DatePicker":
      const renderCustomInput = ({ ref }) => {
        return (
          <>
            <input
              readOnly
              defaultValue={defaultValue}
              placeholder={placeholder}
              value={
                fieldProps.value
                  ? `${fieldProps.value.year}/${fieldProps.value.month}/${fieldProps.value.day}`
                  : ""
              }
              ref={ref}
              style={{
                textAlign: "right",
                padding: "1.9rem 1rem",
                fontSize: "1rem",
                border: "1px solid #d9d9d9",
                width: "100%",
                borderRadius: "12px",
                color: "currentColor",
                height: "48px",
                outline: "none",
                backgroundColor: "white",
              }}
              className="my-custom-input-class datepicker-scroll" // a styling class
              id="departuredDateRef"
            />
          </>
        )
      }
      return (
        <div
          className="col-12 col-md-6 d-flex justify-content-center flex-column align-items-center p-5"
          style={{ gap: "8px" }}
        >
          {isMobile ? (
            <input
              defaultValue={defaultValue}
              onClick={() => {
                setDatePickerModal(true)
              }}
              readOnly
              placeholder="تاریخ تولد"
              value={
                fieldProps.value
                  ? `${fieldProps.value.year}/${fieldProps.value.month}/${fieldProps.value.day}`
                  : ""
              }
              ref={fieldProps.ref}
              style={{
                textAlign: "right",
                padding: "1.9rem 1rem",
                fontSize: "1rem",
                border: "1px solid #b5b5c3",
                width: "100%",
                borderRadius: "12px",
                color: "currentColor",
                height: "48px",
                outline: "none",
                backgroundColor: "white",
              }}
              className="my-custom-input-class datepicker-scroll" // a styling class
              id="departuredDateRef"
            />
          ) : (
            <DatePicker
              defaultValue={defaultValue}
              value={fieldProps.value}
              // value={value}
              calendarPopperPosition="top"
              onChange={(e) => {
                fieldProps.setValue(e)
                // setFieldValue("departureDate", e);
              }}
              name="departureDate"
              ref={fieldProps.ref}
              shouldHighlightWeekends
              renderInput={renderCustomInput}
              style={{ height: "45px", width: "100%" }}
              locale="fa"
            />
          )}
          {isMobile && (
            <Dialog
              className="bg-white"
              PaperProps={{
                style: { borderRadius: "0" },
                className: "datpicker-modal",
              }}
              fullScreen
              open={datepickerModal}
            >
              <div className="d-flex flex-wrap px-5 py-2 bg-white">
                <i
                  className="fa fa-times text-danger mr-auto"
                  style={{ fontSize: "2rem" }}
                  onClick={() => {
                    setDatePickerModal(false)
                  }}
                ></i>
              </div>
              <Calendar
                calendarClassName={"modal-calendar"}
                value={fieldProps.value}
                onChange={(e) => {
                  fieldProps.setValue(e)
                  // setFieldValue("departureDate", e);
                  setDatePickerModal(false)
                }}
                style={{ height: "100%", width: "100%" }}
                locale="fa"
                shouldHighlightWeekends
              />
            </Dialog>
          )}
          {fieldProps.customTouchAndError ? (
            touched && <h6 className="my-auto text-danger mr-auto">{errors}</h6>
          ) : (
            <>
              {touched[name] && (
                <h6 className="my-auto text-danger mr-auto">{errors[name]}</h6>
              )}
            </>
          )}
        </div>
      )
    case "plate":
      return (
        <div
          className="col-12 col-md-6 d-flex justify-content-center  align-items-center p-5"
          style={{ gap: "8px" }}
        >
          <div className="col-4">
            <TextField
              defaultValue={defaultValue}
              className="mx-auto my-2 w-100"
              fullWidth
              max="99"
              onChange={(e) => {
                fieldProps.setValue("plateSeries", fixNumbers(e.target.value))
              }}
              style={{ height: "4rem" }}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <h5 style={{ marginBottom: "4rem" }} className="mr-auto">
                      <span style={{ fontFamily: "sans" }}> ایران</span>
                    </h5>
                  </InputAdornment>
                ),
                style: { direction: "ltr" },
              }}
            />
          </div>
          <div
            className="col-8 p-0"
            style={{
              borderRadius: "7px 13px 13px 7px",
              border: "1px solid #d9d9d9",
              height: "4rem",
            }}
          >
            <MuiThemeProvider theme={theme}>
              <TextField
                defaultValue={defaultValue}
                className="w-25 h-100 font-16"
                variant="outlined"
                type="number"
                max="99"
                InputProps={{
                  style: { fontSize: "16px", fontFamily: "sans" },
                }}
                onChange={(e) => {
                  fieldProps.setValue(
                    "plateNumber3",
                    fixNumbers(e.target.value)
                  )
                }}
              />
              <MatSelect
                className="w-25 h-100"
                SelectDisplayProps={{
                  style: { fontSize: "16px", fontFamily: "sans" },
                }}
                onChange={(e) => {
                  fieldProps.setValue(
                    "plateNumber2",
                    fixNumbers(e.target.value)
                  )
                }}
                variant="outlined"
              >
                {persianAlphabets.map((el) => {
                  return (
                    <option className="font-16 font-sans" value={el.id}>
                      {el.name}
                    </option>
                  )
                })}
              </MatSelect>
              <TextField
                className="w-50 h-100"
                variant="outlined"
                type="number"
                max="999"
                onChange={(e) => {
                  fieldProps.setValue(
                    "plateNumber1",
                    fixNumbers(e.target.value)
                  )
                }}
                InputProps={{
                  style: { fontSize: "16px", fontFamily: "sans" },
                }}
              />
            </MuiThemeProvider>
            <img
              src={plateIMG}
              className="h-100"
              style={{ position: "absolute", left: "0px", top: "0px" }}
            />
          </div>
          {fieldProps.customTouchAndError ? (
            touched && <h6 className="my-auto text-danger mr-auto">{errors}</h6>
          ) : (
            <>
              {touched[name] && (
                <h6 className="my-auto text-danger mr-auto">{errors[name]}</h6>
              )}
            </>
          )}
        </div>
      )
    case "uploadZone":
      return (
        <div
          className="col-12 col-md-6 d-flex justify-content-center flex-column align-items-center p-5"
          style={{ gap: "8px" }}
        >
          {fieldProps.title}
          <DropzoneArea
            id="ImageUrl"
            dropzoneText={placeholder}
            //theme={theme}
            showAlerts={false}
            filesLimit={fieldProps.filesLimit}
            acceptedFiles={fieldProps.acceptedFiles}
            // acceptedFiles={["image/jpeg", "image/png", "image/bmp"]}
            maxFileSize={fieldProps.maxFileSize}
            onChange={async (files) => {
              fieldProps.setValue(files)
            }}
          />
          {fieldProps.customTouchAndError ? (
            touched && <h6 className="my-auto text-danger mr-auto">{errors}</h6>
          ) : (
            <>
              {touched[name] && (
                <h6 className="my-auto text-danger mr-auto">{errors[name]}</h6>
              )}
            </>
          )}
        </div>
      )
    case "custom":
      return fieldProps.render
  }
}

export default Fieldz
